import client from './client';

export async function fetchProviders() {
  const response = await client.get('/api/providers');
  return response.data;
}

export async function createProvider(data) {
  const response = await client.post('/api/providers', data);
  return response.data;
}

export async function updateProvider(id, data) {
  const response = await client.put(`/api/providers/${id}`, data);
  return response.data;
}

export async function deleteProvider(id) {
  const response = await client.delete(`/api/providers/${id}`);
  return response.data;
}

export async function fetchProviderScorecard(id) {
  const response = await client.get(`/api/providers/${id}/scorecard`);
  return response.data;
}

export async function batchAssignProvider(ids, provider_id) {
  const response = await client.patch('/api/backlinks/batch/provider', { ids, provider_id });
  return response.data;
}

export async function batchAssignBatchLabel(ids, batch_label, batch_cost) {
  const response = await client.patch('/api/backlinks/batch/batch-label', { ids, batch_label, batch_cost });
  return response.data;
}
